import React, { FC } from 'react';

const HamburgerMenu: FC<{ color?: string }> = ({ color = '#ffffff' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ color }}>
      <path
        d="M21 17.1484V18.8477H3V17.1484H21ZM21 11.1484V12.8477H3V11.1484H21ZM21 5.14844V6.84766H3V5.14844H21Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HamburgerMenu;
